import styled from "styled-components";

export const StyledAside = styled.aside`
  width: 260px;
  background: ${({ theme }: any) => theme.darkBlue};
  min-height: 100vh;
  /* height: 100%; */
  transition: all ease 0.5s;

  &activeMenu .LogoPart img {
    margin-left: 0px !important;
    width: 50px !important;
  }
  .LogoPart {
    padding: 16px 15px;
    border-bottom: 1px solid #123a69;
  }
  &.activeMenu .LogoPart {
    padding: 16px 15px;
  }
  .navigation {
    // padding: 28px 0px 0px 0;

    nav {
      ul {
        padding-left: 15px;
        // gap: 9px;
        display: grid;
        li {
          .arrow {
            display: none;
          }
          padding: 5px 10px 5px 5px;
          // margin-bottom: 15px;
          position: relative;
          cursor: pointer;

          a {
            color: ${({ theme }: any) => theme.secondaryLightBlue};
            font-size: 15px;
            font-weight: 600;
            .flex {
              .iconWrapper {
                width: 36px;
                height: 36px;
                background: ${({ theme }: any) => theme.blueShade};
                border-radius: 100px;
                img {
                }
              }
              span {
              }
            }
          }
          &.active {
            .arrow {
              display: block;
              right: 0;

              svg {
                position: absolute;
              }
              svg.left {
                position: absolute;
                right: 0;
                top: -23px;
              }
              svg.right {
                position: absolute;
                right: 0;
                top: 51px;
              }
              &:after {
                content: "";
                width: 10px;
                height: 47px;
                background: ${({ theme }: any) => theme.secondaryWhite};
                display: block;
                position: absolute;
                right: 0;
                top: 5px;
              }
            }
            .arrowIcon {
              display: none;
            }
            > a {
              background: ${({ theme }: any) => theme.secondaryWhite};
              border-radius: 100px 0 0 100px;
              display: block;
              padding: 5px 10px 5px 5px;
              color: ${({ theme }: any) => theme.primaryBlue};
            }

            .flex .iconWrapper {
              background: ${({ theme }: any) => theme.secondaryBlue};
            }
          }
          &.show {
            .arrowIcon {
              transform: translateY(-50%) rotate(0deg);
            }
            ul {
              opacity: 1;
              height: auto;
            }
          }

          ul {
            opacity: 0;
            height: 0;
            transition: all ease 0.5s;
            padding-left: 16px;
            padding-top: 17px;
            li {
              padding: 7px 10px 8px 0;
              margin-bottom: 0;
              a {
                color: ${({ theme }: any) => theme.secondaryLightBlue};
                font-size: 14px;
                font-weight: 400;
                padding-left: 24px;
                display: inline-block;
                position: relative;
                width: 100%;
                &:after,
                &:before {
                  background: ${({ theme }: any) => theme.secondaryLightBlue};
                  position: absolute;
                  content: "";
                  display: block;
                }
                &:after {
                  width: 10px;
                  height: 1px;
                  left: 6px;
                  top: 6px;
                }
                &:before {
                  width: 6px;
                  height: 6px;
                  border-radius: 100px;
                  left: 0;
                  top: 3px;
                }
                &.active {
                  color: ${({ theme }: any) => theme.primaryWhite};
                }
              }
              &:after {
                content: "";
                width: 2px;
                height: 32px;
                background: ${({ theme }: any) => theme.secondaryLightBlue};
                position: absolute;
                left: 2px;
                bottom: 15px;
                opacity: 0.5;
              }
            }
          }
          .arrowIcon {
            position: absolute;
            right: 22px;
            top: 24px;
            transform: translateY(-50%) rotate(180deg);
          }
          &.active {
            .arrowIcon {
              transform: translateY(-50%) rotate(0deg);
            }
            ul {
              opacity: 1;
              height: auto;
            }
          }
        }
      }
    }
  }
  &.activeMenu {
    .navigation {
      nav {
        ul {
          gap: 9px;
          margin-top: 11px;
        }
      }
    }
  }
`;
